import { helper } from '@ember/component/helper';
import { TransferStep } from '@square/dashboard-protos/models/squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step';
function getToastStyles([toastStyle]) {
  switch (toastStyle) {
    case TransferStep.TransferResult.Toast.Style.SUCCESS:
      return 'success';
    case TransferStep.TransferResult.Toast.Style.WARNING:
      return 'warning';
    case TransferStep.TransferResult.Toast.Style.CRITICAL:
      return 'critical';
    case TransferStep.TransferResult.Toast.Style.INFO:
    default:
      return 'info';
  }
}
export default helper(getToastStyles);